import BaseLayout from '@/components/layouts/BaseLayout';

export default [{
    path: '/request-support',
    navbar: false,
    title: 'request-support',
    icon: 'ion ion-md-mail',
    name: 'request-support',
    redirect: 'request-support/request_support_form',
    meta: { perm: 'Navbar.RequestSupport' },
    component: BaseLayout,
    children: [{
            path: 'request_support_form',
            title: 'request_support_form',
            icon: 'fas fa-envelope',
            name: 'request_support_form',
            meta: { perm: 'Navbar.RequestSupport' },
            component: () =>
                import ('@/pages/RequestSupportPage/RequestSupportForm'),
        },
        {
            path: 'request_support_form_history',
            title: 'request_support_form_history',
            icon: 'fas fa-envelope',
            name: 'request_support_form_history',
            meta: { perm: 'Navbar.RequestSupportFormList' },
            component: () =>
                import ('@/pages/RequestSupportPage/RequestSupportList'),
        },
    ],
}, ];